const errors = {
    100: "The given phone number already exists on a line of service."
}

export default errors;